import { Formik } from "formik";
import { SetStateAction, createContext, useState } from "react";
import FormKeHoach from "./components/FormKeHoach";
import * as Yup from "yup";

export interface XayDungKeHoachContextProps {
    dsKeHoach: any;
    setDsKeHoach: SetStateAction<any>;
    detailPhieuKeHoach: any;
    setDetailPhieuKeHoach: SetStateAction<any>;

}

const initialContext = {
    dsKeHoach: [],
    setDsKeHoach: () => { },
    detailPhieuKeHoach: [],
    setDetailPhieuKeHoach: () => { },
}

export const XayDungKeHoachContext = createContext<XayDungKeHoachContextProps>(initialContext)
interface Props {
    warehouseId?: number;
    className?: any;
}
export const HoiChanKhamBenh = (props: Props) => {
    const { warehouseId, className } = props;
    const [dsKeHoach, setDsKeHoach] = useState([]);
    const [detailPhieuKeHoach, setDetailPhieuKeHoach] = useState({});

    let validationSchema = Yup.object({});
    const handleFormSubmit = (values: any) => { }

    return (
        <Formik<any>
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
        >
            <XayDungKeHoachContext.Provider
                value={{
                    dsKeHoach: dsKeHoach,
                    setDsKeHoach: setDsKeHoach,
                    detailPhieuKeHoach,
                    setDetailPhieuKeHoach,
                }}
            >
                <div className="bg-white">
                    <div className="flex-1 flex flex-column">
                        <div className="py-1">
                            <FormKeHoach
                                className={className}
                                warehouseId={warehouseId}
                            />
                        </div>
                    </div>
                </div>
            </XayDungKeHoachContext.Provider>
        </Formik>

    )
}

export default HoiChanKhamBenh;
